import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-disabled", "aria-label", "tabindex"]

import { computed } from 'vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DragHandle',
  props: {
    disabled: { type: Boolean, default: false },
    ariaLabel: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const ariaLabelValue = computed(() => props.ariaLabel ?? i18n.t('ドラッグして並び替え').toString());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["drag-handle", { 'drag-handle--disabled': _ctx.disabled }]),
    "aria-disabled": _ctx.disabled,
    "aria-label": ariaLabelValue.value,
    tabindex: _ctx.disabled ? undefined : 0,
    role: "button"
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
      return _createElementVNode("span", {
        key: index,
        class: "drag-handle__dot"
      })
    }), 64))
  ], 10, _hoisted_1))
}
}

})